export const PV_CHECKLIST_STATIC = [
  {
    title: "D.C. side – Inspection Requirements",
    subsections: [
      {
        subtitle: "d.c. system – general",
        items: [
          {
            key: "dc_general_a",
            label:
              "(a) General check to confirm system complies with relevant standards.",
          },
          {
            key: "dc_general_b",
            label: "(b) PV voltage suitable for location",
          },
          {
            key: "dc_general_c",
            label:
              "(c) Components selected and erected to suit location and external influences",
          },
          {
            key: "dc_general_d",
            label:
              "(d) Roof and building penetrations weatherproof (where applicable)",
          },
        ],
      },
      {
        subtitle: "d.c. system – protection against shock",
        items: [
          {
            key: "dc_shock_a",
            label: "(a) Verification of protective measures against shock",
          },
          {
            key: "dc_shock_b",
            label:
              "(b) Parts selected and erected so as to minimise the risk of earth faults and short circuits.",
          },
        ],
      },
      {
        subtitle: "d.c. system – protection against insulation faults",
        items: [
          {
            key: "dc_insulation_a",
            label:
              "(a) Identification if inverter has at least simple separation",
          },
          {
            key: "dc_insulation_b",
            label: "(b) Identification of any functional earthing",
          },
          {
            key: "dc_insulation_c",
            label:
              "(c) Presence of earth insulation resistance detection and alarm system",
          },
          {
            key: "dc_insulation_d",
            label:
              "(d) Presence of earth residual current monitoring detection and alarm system",
          },
        ],
      },
      {
        subtitle: "d.c. system – protection against over current",
        items: [
          {
            key: "dc_overcurrent_a",
            label: "(a) IMOD_MAX_OCPR > possible reverse current",
          },
          {
            key: "dc_overcurrent_b",
            label:
              "(b) String cables sized appropriately for prospective fault currents",
          },
          {
            key: "dc_overcurrent_c",
            label:
              "(c) String/array over current protective devices correctly specified and installed",
          },
        ],
      },
      {
        subtitle: "d.c. system – earthing and bonding",
        items: [
          {
            key: "dc_earthing_a",
            label: "(a) Check of any functional earth connections",
          },
          {
            key: "dc_earthing_b",
            label:
              "(b) Check functional earth fault interrupters are fitted (where required)",
          },
          {
            key: "dc_earthing_c",
            label: "(c) Check of any earthing and/or equipotential bonding",
          },
        ],
      },
      {
        subtitle: "d.c. system – lightning and overvoltage",
        items: [
          { key: "dc_lightning_a", label: "(a) Verify wiring loops minimised" },
          {
            key: "dc_lightning_b",
            label: "(b) Measures in place to protect long cables",
          },
          {
            key: "dc_lightning_c",
            label: "(c) SPDs, where fitted, suitable selected and erected",
          },
        ],
      },
      {
        subtitle: "d.c. system – equipment selection and erection",
        items: [
          {
            key: "dc_equipment_a",
            label:
              "(a) All d.c. components rated for d.c. and for voltage and current maxima",
          },
          {
            key: "dc_equipment_b",
            label:
              "(b) Wiring selected and erected to suit external influences (wind, UV etc.)",
          },
          {
            key: "dc_equipment_c",
            label:
              "(c) String/array isolation and disconnection devices correctly specified and located",
          },
          {
            key: "dc_equipment_d",
            label: "(d) Plug and sockets are of same type and correctly mated",
          },
        ],
      },
      {
        subtitle: "a.c. system",
        items: [
          {
            key: "ac_a",
            label: "(a) Means of isolating inverter provided on a.c. side",
          },
          { key: "ac_b", label: "(b) Isolators correctly connected" },
          { key: "ac_c", label: "(c) Inverter parameters correctly specified" },
          {
            key: "ac_d",
            label: "(d) RCDs correctly selected and installed (where fitted)",
          },
        ],
      },
      {
        subtitle: "Labelling",
        items: [
          {
            key: "label_a",
            label: "(a) All parts correctly labelled and suitably durable",
          },
          {
            key: "label_b",
            label: "(b) Schematics and other signs suitably displayed",
          },
        ],
      },
    ],
  },

  // SECOND SECTION
  {
    title: "D.C. side – Minimum Test Requirements",
    subsections: [
      {
        subtitle: "Continuity of earthing/equipotential bonding conductors",
        items: [
          {
            key: "min_continuity_a",
            label:
              "(a) Test to ensure the continuity of earthing and/or equipotential bonding conductors (if fitted)",
          },
          {
            key: "min_continuity_b",
            label: "(b) Connection to main earthing terminal verified",
          },
        ],
      },
      {
        subtitle: "Polarity Test",
        items: [
          {
            key: "min_polarity",
            label:
              "Test to ensure that all strings and arrays are correctly marked and connected",
          },
        ],
      },
      {
        subtitle: "Combiner box test",
        items: [
          {
            key: "min_combiner",
            label:
              "Test to ensure that all strings are correctly connected within a combiner box (if fitted)",
          },
        ],
      },
      {
        subtitle: "String open circuit voltage test",
        items: [
          {
            key: "min_voc",
            label:
              "Test to ensure that module strings are correctly installed and that the right number of modules are connected within a string",
          },
        ],
      },
      {
        subtitle: "String circuit current tests",
        items: [
          {
            key: "min_isc_a",
            label:
              "(a) Test to ensure that there are no major faults within a string",
          },
          {
            key: "min_isc_b",
            label: "(b) Short-circuit and operation test options presented",
          },
        ],
      },
      {
        subtitle: "Functional tests",
        items: [
          {
            key: "min_functional_a",
            label: "(a) Tests to ensure switchgear operated correctly",
          },
          {
            key: "min_functional_b",
            label: "(b) Tests to ensure inverters operating correctly",
          },
        ],
      },
      {
        subtitle: "Insulation resistance test",
        items: [
          {
            key: "min_insulation",
            label:
              "Test of the insulation resistance of PV string and array circuits.",
          },
        ],
      },
    ],
  },
];
